import styled from 'styled-components';

export const EproposalContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 24px;
  border-radius: 8px;
`;

export const EproposalFormsWrapper = styled.div.attrs({})`
  background: ${(props) => props.theme.palette.lightgrey.main};
  height: 100vh;
  padding: 24px;
`;
